export default "__VITE_ASSET__DIkMLAoj__"